import { Select } from 'antd';
import { getGenderOptions } from 'constants/form';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

interface Props {
  value: any;
  onValueChange: (value: any) => void;
}

const GenderPickerEditor = ({ value, onValueChange }: Props) => {
  const { t } = useTranslation();
  const GENDER_OPTIONS = useMemo(() => getGenderOptions(t), [t]);
  return (
    <Select
      value={value}
      options={GENDER_OPTIONS}
      style={{ minWidth: 90 }}
      onChange={value => onValueChange(value === '' ? null : value)}
    />
  );
};

export default GenderPickerEditor;
